import { RTasksTemplate } from "@/modules/Tasks/Template/RTasksTemplate";
import { RouteConfig } from "vue-router";
import { RNewTasksBrowse } from "@/modules/Tasks/Browse/RNewTasksBrowse";

export const REmployeeTasks: RouteConfig = {
  path: "tasks",
  component: () =>
    import(
      /* webpackChunkName: "employee-tasks" */
      "./VEmployeeTasks.vue"
    ),
  meta: {
    title: "Tasks",
    icon: "list-outline",
    newIcon: "list-check",
  },
  children: [RNewTasksBrowse, RTasksTemplate],
};
